<script setup lang="ts">
  import { StatusBar } from "@ui-kit";
  import { useProfileOptions } from "@src/hooks";

  const { hasPermission } = useProfileOptions();
</script>

<template>
  <StatusBar :rfidPowerVisible="hasPermission('mobile.debug')" />
</template>
